<template>
  <div class="profile-container container">
    <div class="profile-portrait">
      <div class="profile-portrait-container">
      <figure>
        <img src="../../assets/images/shuab-gamote.jpg" alt="Shuab Gamote">
          </figure>
         <div class="finger-print"><img src="@/assets/images/fingerprints/fingerprint-three.svg" alt=""></div>
      </div>
    </div>
    <div class="profile-statement">

      <h2>Shuab Gamote</h2>
      
      <p class="job-title">Project Manager at the Student Union</p>

      <p class="profile-statement-interviewer">Tell us a little bit about yourself</p>

      <p class="profile-statement-interviewed">I am a final year student in Accounting and Finance and the Project Manager for the BAME Ambassador Project at Manchester Metropolitan University Students’ Union. Since joining the university as a student in 2018, I have been actively involved in University activities, from running for Students’ Union President to being a spokesperson for First Generation students. My interests range from being a national ambassador for mentoring with One Million Mentors to local community work with disadvantaged high schools and local community led organisations.</p>

      <p class="profile-statement-interviewer">What inspires you within your role?</p>

      <p>I have been incredibly fortunate to have incredibly inspiring people around me, which has allowed me to make the most of the opportunities given to me. I want all students to have the same confidence to say yes to opportunities and strive to be the greatest versions of themselves.</p>

      <p class="profile-statement-interviewer">What is something that you love about your culture or heritage?</p>

      <p>Somaliland is all about family this can be as small as the nuclear family or as big as your entire city. Being family in my culture is not just a title but a responsibility to take care and do good by one another and the right to expect the same back.</p>

      <p class="profile-statement-interviewer">What does it look like to bring your whole self to your work?</p>

      <p>Bringing my whole self to work is being the positive outgoing person I am unapologetically, not feeling weird about saying good morning to every colleague that I pass. Bringing my whole self to work is being proud of the work that I do, the person that I am and the organisation I work for.</p>

      <p class="profile-statement-interviewer">How do you think MMU can best celebrate their Black, Asian, and Ethnic Minority staff and students?</p>

      <p>Celebrating MMU BAME Staff is celebrating staff for who they are and what they believe, so having more celebrations around different cultural events and being aware of difficulties that staff may have around this busy time in their lives.</p>

      <p class="profile-statement-interviewer">What are you most proud of?</p>

      <p>On a professional level I am most proud of how our team of BAME student staff excelled during the pandemic and made sure that the voices of BAME students are being heard. On a more personal level I am incredibly proud of how I dealt with the pressures of working full time and studying full time in my final year at university.</p>

    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

  // .profile-container {
  // flex-direction: row-reverse;
  // }

  .profile-portrait-container {
    justify-content: flex-start;

    & figure {
      text-align: left;
    }
  }

  // .profile-statement {
  //   padding-right: 5rem;
  //   // padding-left: 5rem;
  // }
  

</style>